module.exports = __webpack_public_path__ + "img/Slika2_2021.d9d4136c.png";